import React from 'react';
import { usePopup } from '../context/PopupContext';
import Sheet from './ui/Sheet';
import Icon from './ui/Icon';
import './GlobalPopup.css';

const TOAST_ICON = { success: 'success', error: 'error', info: 'info', warning: 'warning' };

// The app-wide blocking dialog (a sheet on phones) and the toast stack. The `btn-popup-*` class names are kept:
// existing flows and tests locate the buttons by them.
const GlobalPopup = () => {
  const { popup, toasts, dismissToast } = usePopup();
  const confirm = popup.type === 'confirm';

  return (
    <>
      <Sheet
        open={!!popup.show}
        onClose={confirm ? popup.onCancel : popup.onConfirm}
        title={popup.title || (confirm ? 'Confirm' : 'Heads up')}
        dismissible
        hideClose
        footer={(
          <>
            {confirm && <button type="button" className="z-btn z-btn--secondary btn-popup-cancel" onClick={popup.onCancel}>Cancel</button>}
            <button type="button" data-autofocus className="z-btn z-btn--primary btn-popup-confirm" onClick={popup.onConfirm}>{confirm ? 'Confirm' : 'OK'}</button>
          </>
        )}
      >
        <p className="z-popup-message">{popup.message}</p>
      </Sheet>

      <div className="z-toasts" aria-live="polite" aria-atomic="false">
        {toasts.map(t => (
          <div key={t.id} className={`z-toast z-toast--${t.tone}`} role="status">
            <Icon name={TOAST_ICON[t.tone] || 'info'} size={20} />
            <span className="z-toast-text">{t.message}</span>
            <button type="button" className="z-toast-close" onClick={() => dismissToast(t.id)} aria-label="Dismiss"><Icon name="close" size={16} /></button>
          </div>
        ))}
      </div>
    </>
  );
};

export default GlobalPopup;
